export default __webpack_public_path__ + "static/media/person_2@2x.4d743104.png";